"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationRepository = void 0;
const pino_1 = __importDefault(require("pino"));
const httpRepository_1 = __importDefault(require("./httpRepository"));
const sessionRepository_1 = require("./sessionRepository");
const logger = (0, pino_1.default)();
function _buildUrl(conversationId) {
    return ['/rest', 'conversations', conversationId, 'events'].join('/');
}
function _buildStreamUrl() {
    return ['/rest', 'conversations', 'stream'].join('/');
}
exports.ConversationRepository = {
    addMessage: (options) => httpRepository_1.default.tradeshiftGo()
        .put(_buildUrl(options.conversationId), options)
        .then((response) => {
        return response.data;
    }),
    getEvents: async (options) => {
        if (!options.conversationId) {
            logger.error('conversationId is required');
            await sessionRepository_1.SessionRepository.logout();
            globalThis.location.pathname = '/signin/login';
        }
        const config = {
            params: {
                after: options.after,
                polling: options.polling,
            },
        };
        const response = await httpRepository_1.default.tradeshiftGo().get(_buildUrl(options.conversationId), config);
        return response.data;
    },
    getStream: async (options) => {
        const config = {
            params: {
                after: options.after,
            },
        };
        const response = await httpRepository_1.default.tradeshiftGo().get(_buildStreamUrl(), config);
        return response.data;
    },
};
